// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  width: 830px; /* Adjust the desired width */
  margin: 0 auto; /* Center the container horizontally */
  overflow-x: auto;
  
}


.tournament{
  display:flex;
  flex-direction:row;
  justify-content: center; /* Center the tournament bracket within the container */
  
}
.round{
  display:flex;
  flex-direction:column;
 
  width:200px;
  list-style:none;
  padding:0;
}
  .round .spacer{ flex-grow:1; }
  .round .spacer:first-child ,
  .round .spacer:last-child{ flex-grow:1; }

  .round .game-spacer{
    flex-grow:1;
  }

/*
 *  General Styles
*/
body{
  font-family:sans-serif;
  font-size:small;
  padding:0px;
  line-height:1.4em;
}

li.game{
  padding-left:20px;
}

  li.game.winner{
    font-weight:bold;
    font-size: medium;
    color:rgb(143, 28, 215);

  }
  li.game span{
    float:right;
    margin-right:5px;
  }

  li.game-top{ border-bottom:1px solid #aaa; }

  li.game-spacer{ 
    border-right:1px solid #aaa;
    min-height:50px;
    text-align: center;
  }

  li.game-bottom{ 
    border-top:1px solid #aaa;
  }

  li.spacer {
    flex-grow: 1;
    min-height: 25px; /* Initial height of the spacer */
    transition: min-height 0.3s ease; /* Transition effect for height change */
  }
  
  .round.round-2 li.spacer {
    min-height: 65px; /* Double the height in the second round */
  }

  .round.round-2 li.game-spacer {
    min-height: 130px; /* Double the height in the second round */
  }
  
  .round.round-3 li.spacer {
    min-height: 170px; /* Double the height in the third round */
  }

  .round.round-3 li.game-spacer {
    min-height: 230px; /* Double the height in the third round */
  }

  .round.round-4 li.spacer {
    min-height: 360px; /* Double the height in the third round */
  }

  .round.round-4 li.game-spacer {
    min-height: 300px; /* Double the height in the third round */
  }

 .round.round-4 li.game.winner{
    font-weight:bold;
    font-size: medium;
    color:rgb(28, 213, 34);

  }`, "",{"version":3,"sources":["webpack://./src/components/Playoff.css"],"names":[],"mappings":"AAAA;EACE,YAAY,EAAE,6BAA6B;EAC3C,cAAc,EAAE,sCAAsC;EACtD,gBAAgB;;AAElB;;;AAGA;EACE,YAAY;EACZ,kBAAkB;EAClB,uBAAuB,EAAE,uDAAuD;;AAElF;AACA;EACE,YAAY;EACZ,qBAAqB;;EAErB,WAAW;EACX,eAAe;EACf,SAAS;AACX;EACE,gBAAgB,WAAW,EAAE;EAC7B;6BAC2B,WAAW,EAAE;;EAExC;IACE,WAAW;EACb;;AAEF;;CAEC;AACD;EACE,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;EAEE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;;EAEzB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA,aAAa,4BAA4B,EAAE;;EAE3C;IACE,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,gBAAgB,EAAE,iCAAiC;IACnD,gCAAgC,EAAE,wCAAwC;EAC5E;;EAEA;IACE,gBAAgB,EAAE,0CAA0C;EAC9D;;EAEA;IACE,iBAAiB,EAAE,0CAA0C;EAC/D;;EAEA;IACE,iBAAiB,EAAE,yCAAyC;EAC9D;;EAEA;IACE,iBAAiB,EAAE,yCAAyC;EAC9D;;EAEA;IACE,iBAAiB,EAAE,yCAAyC;EAC9D;;EAEA;IACE,iBAAiB,EAAE,yCAAyC;EAC9D;;CAED;IACG,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;;EAExB","sourcesContent":[".container {\n  width: 830px; /* Adjust the desired width */\n  margin: 0 auto; /* Center the container horizontally */\n  overflow-x: auto;\n  \n}\n\n\n.tournament{\n  display:flex;\n  flex-direction:row;\n  justify-content: center; /* Center the tournament bracket within the container */\n  \n}\n.round{\n  display:flex;\n  flex-direction:column;\n \n  width:200px;\n  list-style:none;\n  padding:0;\n}\n  .round .spacer{ flex-grow:1; }\n  .round .spacer:first-child ,\n  .round .spacer:last-child{ flex-grow:1; }\n\n  .round .game-spacer{\n    flex-grow:1;\n  }\n\n/*\n *  General Styles\n*/\nbody{\n  font-family:sans-serif;\n  font-size:small;\n  padding:0px;\n  line-height:1.4em;\n}\n\nli.game{\n  padding-left:20px;\n}\n\n  li.game.winner{\n    font-weight:bold;\n    font-size: medium;\n    color:rgb(143, 28, 215);\n\n  }\n  li.game span{\n    float:right;\n    margin-right:5px;\n  }\n\n  li.game-top{ border-bottom:1px solid #aaa; }\n\n  li.game-spacer{ \n    border-right:1px solid #aaa;\n    min-height:50px;\n    text-align: center;\n  }\n\n  li.game-bottom{ \n    border-top:1px solid #aaa;\n  }\n\n  li.spacer {\n    flex-grow: 1;\n    min-height: 25px; /* Initial height of the spacer */\n    transition: min-height 0.3s ease; /* Transition effect for height change */\n  }\n  \n  .round.round-2 li.spacer {\n    min-height: 65px; /* Double the height in the second round */\n  }\n\n  .round.round-2 li.game-spacer {\n    min-height: 130px; /* Double the height in the second round */\n  }\n  \n  .round.round-3 li.spacer {\n    min-height: 170px; /* Double the height in the third round */\n  }\n\n  .round.round-3 li.game-spacer {\n    min-height: 230px; /* Double the height in the third round */\n  }\n\n  .round.round-4 li.spacer {\n    min-height: 360px; /* Double the height in the third round */\n  }\n\n  .round.round-4 li.game-spacer {\n    min-height: 300px; /* Double the height in the third round */\n  }\n\n .round.round-4 li.game.winner{\n    font-weight:bold;\n    font-size: medium;\n    color:rgb(28, 213, 34);\n\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
